import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { MemoryRouter } from 'react-router-dom';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { RootStoreContext } from './stores';
import { RootStore } from './stores/RootStore';
import { ErrorContextProvider } from './components/ErrorContextProvider/ErrorContextProvider';
import { msalConfig } from './services/msal/authConfig';
// Don't change the order of index.scss
import './index.scss';
import './tailwind.css';
import App from './App';

// TODO Remove this line
import './utils/mockTokenExpired';

const msalInstance = new PublicClientApplication(msalConfig);

const rootElement = document.getElementById('root') as HTMLElement;

const root = ReactDOM.createRoot(rootElement);

root.render(
  <RootStoreContext.Provider value={new RootStore()}>
    <ErrorContextProvider>
      <MsalProvider instance={msalInstance}>
        <MemoryRouter>
          <App />
        </MemoryRouter>
      </MsalProvider>
    </ErrorContextProvider>
  </RootStoreContext.Provider>,
);

reportWebVitals(null);
